import React from 'react';
import BarkLogo from '../assets/bark-logo.png'
import HintTooltip from '../hint-tooltip/hint-tooltip';
import { PoweredLabelWrapper, PoweredText, LogoImage } from './index.style';

export interface PoweredLabelProps {
    type: string;
    withInfo?: boolean;
    isMobile?: boolean;
    pageType?: string;
    hintDirection?: 'bottom' | 'top';
}

const PoweredLabel: React.FC<PoweredLabelProps> = ({ type, withInfo = false, isMobile = false, pageType = 'srp', hintDirection = 'bottom' }) => {
    return (
        <PoweredLabelWrapper withInfo={withInfo} isMobile={isMobile} pageType={pageType}>
            
            {type === 'Bark' && (
                <>
                    <PoweredText>Powered by</PoweredText>
                    <LogoImage src={BarkLogo} alt="BarkLogo" withInfo={withInfo} />
                </>
            )}
            {(type === 'GT' || type === 'google') && (
                <PoweredText>Powered by Google</PoweredText>
            )}
            {withInfo && (
                <HintTooltip
                    content="An Ad made in partnership with Bark."
                    triggerColor="grey"
                    closeBtnColor="lightGrey"
                    theme="white"
                    elName="bark"
                    size='small'
                    type='Bark'
                    hintDirection={hintDirection}
                />
            )}
        </PoweredLabelWrapper>
    );
};

export default PoweredLabel;
